document.addEventListener("DOMContentLoaded", function () {
  let div = document.getElementById("sticky-button");
  let container = div?.parentElement;

  function updatePosition() {
    if (!div || !container) return;
    let containerRect = container.getBoundingClientRect();
    let divRect = div.getBoundingClientRect();

    container.style.height = div.offsetHeight + "px"; // Ensure container maintains height

    if (containerRect.bottom <= window.innerHeight) {
      div.classList.remove("sticky-fixed");
      div.classList.add("sticky-absolute");
    } else {
      div.classList.remove("sticky-absolute");
      div.classList.add("sticky-fixed");
    }
  }

  window.addEventListener("scroll", updatePosition);
});

/* Mini Cart (product added to cart pop-up) */

document.addEventListener("liquid-ajax-cart:request-end", function (event) {
  const { requestState, cart, previousCart, sections } = event.detail;

  if (requestState.requestType === "change" && requestState.responseData?.ok) {
    const currentCart = cart.items || [];

    previousCart.items.forEach((prevItem) => {
      const stillExists = currentCart.some(
        (currItem) => currItem.key === prevItem.key
      );
      if (!stillExists) {
        document.querySelector(
          ".minicart__header h2.removed .product"
        ).innerHTML = prevItem.title;
        document
          .querySelector(".minicart__header h2.title")
          .classList.add("hidden");
        document
          .querySelector(".minicart__header h2.removed")
          .classList.remove("hidden");
      }
    });
  } else {
    document.querySelector(".minicart__header h2.removed .product").innerHTML =
      "";
    document
      .querySelector(".minicart__header h2.title")
      .classList.remove("hidden");
    document
      .querySelector(".minicart__header h2.removed")
      .classList.add("hidden");
  }
});
